// src/pages/LegalPage.js
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import styles from "./LegalPage.module.css";

const LegalPage = () => {
  const { slug } = useParams(); 
  const [document, setDocument] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const API_BASE = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000";

  useEffect(() => {
    setLoading(true);
    setError(null);

    fetch(`${API_BASE}/api/legal/${slug}/`)
      .then((res) => {
        if (!res.ok) throw new Error("Document not found.");
        return res.json();
      })
      .then((data) => {
        setDocument(data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, [slug, API_BASE]);

  if (loading) return <div className={styles.center}>Loading document...</div>;
  if (error) return <div className={styles.error}>{error}</div>;

  return (
    <div className={styles.legalPageWrapper}>
      <div className={styles.legalContainer}>
        <h1 className={styles.docTitle}>{document?.title}</h1>
        <p className={styles.lastUpdated}>
          Last updated: {document?.updated_at ? new Date(document.updated_at).toLocaleDateString() : "N/A"}
        </p>
        <div className={styles.divider} />
        
        {/* CRITICAL: This parses your database HTML strings into real webpage content */}
        <div 
          className={styles.documentBody}
          dangerouslySetInnerHTML={{ __html: document?.content }} 
        />
      </div>
    </div>
  );
};

export default LegalPage;